var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-body-1 font-weight-black white--text mb-1 ml-1"},[_vm._v(" Cidades ")]),_c('div',{staticClass:"cities-list"},_vm._l((_vm.cities),function(ref,i){
var title = ref.title;
var slug = ref.slug;
return _c('div',{key:i},[_c('v-btn',{staticClass:"text-none text-body-2 font-weight-bold px-1",attrs:{"to":'/' + slug,"color":"grey lighten-4","text":"","small":""}},[_vm._v(" "+_vm._s(title)+" ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }